/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ScheduledChangeVisibleState =
  (typeof ScheduledChangeVisibleState)[keyof typeof ScheduledChangeVisibleState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduledChangeVisibleState = {
  scheduled: 'scheduled',
  draft_ready: 'draft_ready',
  applying: 'applying',
  live: 'live',
  failed: 'failed',
  superseded: 'superseded',
  cancelled: 'cancelled',
} as const;
